import gql from "graphql-tag";
const VERIFY_TWOFA = gql`
  mutation verify2fa($verify2faInput: VerifyTwoFactorInput!) {
    verify2fa(verify2faInput: $verify2faInput) {
        accessToken
        refreshToken
        username
        isTwoFaEnabled,
        twoFaToken
        firstname
        surname
    }
  }
`;

export default VERIFY_TWOFA;
